import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'primeicons/primeicons.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
//import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// ✅ Register service worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((reg) => {
          console.log('[SW] Registered successfully:', reg);
        })
        .catch((err) => {
          console.error('[SW] Registration failed:', err);
        });
    });
}